import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/update",
      name: "update",
      component: () =>
        import(/* webpackChunkName: 'update' */ "./views/update.vue")
    },
    {
      path: "/registry",
      name: "registry",
      component: () =>
        import(/* webpackChunkName: 'registry' */ "./views/Registry/index.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: 'login' */ "./views/Login/Login.vue")
    },
    {
      path: "/password",
      name: "password",
      redirect: to => {
        return {
          name: "registry",
          query: {
            type: "password"
          }
        };
      }
    },
    {
      path: "/",
      name: "index",
      redirect: "/home",
      component: () =>
        import(/* webpackChunkName: 'index' */ "./views/layout.vue"),
      children: [
        {
          path: "/home",
          name: "home",
          component: () =>
            import(/* webpackChunkName: 'home' */ "./views/home.vue")
        },
        {
          path: "/putOrder",
          name: "DWTF",
          component: () =>
            import(
              /* webpackChunkName: 'putOrder' */ "./views/PutOrder/index.vue"
            )
        },
        {
          path: "/putOrderMap",
          name: "DTTF",
          component: () =>
            import(
              /* webpackChunkName: 'putOrderMap' */ "./views/PutOrderMap/putOrderMap.vue"
            )
        },
        {
          path: "/putOrderWifi",
          name: "WLGGTF",
          component: () =>
            import(
              /* webpackChunkName: 'putOrderWifi' */ "./views/PutOrderWifi/index.vue"
            )
        },
        {
          path: "/putOrderH5Realtime",
          name: "SSGGTF",
          component: () =>
            import(
              /* webpackChunkName: 'putOrderH5Realtime' */ "./views/PutOrderH5Realtime/index.vue"
            )
        },
        {
          path: "/H5Edit",
          name: "H5Edit",
          component: () =>
            import(/* webpackChunkName: 'H5Edit' */ "./views/H5Edit/index.vue")
        },
        {
          path: "/H5Add",
          name: "H5Add",
          component: () =>
            import(/* webpackChunkName: 'H5Add' */ "./views/H5Edit/add.vue")
        },
        {
          path: "/orderVideo",
          name: "orderVideo",
          component: () =>
            import(
              /* webpackChunkName: 'orderVideo' */ "./views/order/orderVideo.vue"
            )
        },
        {
          path: "/putOrderTimeLimit",
          name: "XLGGTF",
          component: () =>
            import(
              /* webpackChunkName: 'putOrderTimeLimit' */ "./views/PutOrderTimeLimit/index.vue"
            )
        },
        {
          path: "/putCprplus",
          name: "CPRPLUS",
          component: () =>
            import(
              /* webpackChunkName: 'putCprplus' */ "./views/PutCprPlus/index.vue"
            )
        },
        {
          path: "/mapOrderDetail",
          name: "mapOrderDetail",
          component: () =>
            import(
              /* webpackChunkName: 'orderDetail' */ "./views/order/orderDetail.vue"
            )
        },
        {
          path: "/orderList",
          name: "orderList",
          component: () =>
            import(
              /* webpackChunkName: 'orderList' */ "./views/order/orderList.vue"
            )
        },
        {
          path: "/orderPay",
          name: "orderPay",
          component: () =>
            import(
              /* webpackChunkName: 'orderPay' */ "./views/order/OrderPay.vue"
            )
        },
        {
          path: "/payOk",
          name: "payOk",
          component: () =>
            import(
              /* webpackChunkName: 'payOk' */ "./views/order/OrderPayOk.vue"
            )
        },
        {
          path: "/message",
          name: "message",
          component: () =>
            import(/* webpackChunkName: 'message' */ "./views/message.vue")
        },
        {
          path: "/rechargeOffline",
          name: "rechargeOffline",
          component: () =>
            import(
              /* webpackChunkName: 'rechargeOffline' */ "./views/rechargeOffline.vue"
            )
        },
        {
          path: "/recharge",
          name: "recharge",
          component: () =>
            import(/* webpackChunkName: 'recharge' */ "./views/recharge.vue")
        },
        {
          path: "/rechargeRes",
          name: "rechargeRes",
          component: () =>
            import(
              /* webpackChunkName: 'rechargeRes' */ "./views/rechargeRes.vue"
            )
        },
        {
          path: "/rechargeList",
          name: "rechargeList",
          component: () =>
            import(
              /* webpackChunkName: 'rechargeList' */ "./views/rechargeList.vue"
            )
        },
        {
          path: "/spentList",
          name: "spentList",
          component: () =>
            import(/* webpackChunkName: 'spentList' */ "./views/spentList.vue")
        },
        {
          path: "/waterDetail",
          name: "waterDetail",
          component: () =>
            import(
              /* webpackChunkName: 'spentList' */ "./views/Finance/WaterDetail.vue"
            )
        },
        {
          path: "/accountInfo",
          name: "accountInfo",
          component: () =>
            import(
              /* webpackChunkName: 'accountInfo' */ "./views/Account/AccountInfo"
            )
        },
        {
          path: "/modifyPhone",
          name: "modifyPhone",
          component: () =>
            import(
              /* webpackChunkName: 'modifyPhone' */ "./views/Account/ModifyPhone.vue"
            )
        },
        {
          path: "/modifyPassword",
          name: "modifyPassword",
          component: () =>
            import(
              /* webpackChunkName: 'modifyPassword' */ "./views/Account/ModifyPassword.vue"
            )
        },
        {
          path: "/coupon",
          name: "coupon",
          component: () =>
            import(/* webpackChunkName: 'coupon' */ "./views/coupon.vue")
        },
        {
          path: "/orderReport",
          name: "orderReport",
          component: () =>
            import(
              /* webpackChunkName: 'orderReport' */ "./views/orderReport/orderReport.vue"
            )
        },
        {
          path: "contrastReport",
          name: "contrastReport",
          component: () => import(/* webpackChunkName: 'contrastReport' */ "./views/contrastReport/contrastReport.vue")
        },
        {
          path: "/feedback",
          name: "feedback",
          component: () =>
            import(/* webpackChunkName: 'feedback' */ "./views/feedback.vue")
        },
        {
          path: "/commission",
          name: "commission",
          component: () =>
            import(
              /* webpackChunkName: 'commission' */ "./views/commission.vue"
            )
        }
      ]
    },
    {
      path: "*",
      redirect: "/login"
    }
  ]
});

router.onError(error => {
  const reg = new RegExp(/Loading chunk .* failed/, "ig");
  if (reg.test(error.message)) {
    location.replace(router.history.pending.fullPath);
  }
});

export default router;
